import React, { useState } from 'react';
import {
  Button,
  Checkbox,
  Form,
  Input,
  Col,
  Row,
  DatePicker,
  Select,
  message,
  Divider,
  Radio,
} from 'antd';
import IntlMessages from '@crema/utility/IntlMessages';
import { useIntl } from 'react-intl';
import { useAuthMethod } from '@crema/utility/AuthHooks';
import '../AuthWrapper.style.less';
import { Link, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { LoginWithSocial } from '../Signin/LoginWithSocial';

const { Option } = Select;

const SignupJwtAuth = () => {
  const { messages } = useIntl();
  const { signUpUser } = useAuthMethod();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = (values) => {
    setIsLoading(true);
    signUpUser(
      {
        ...values,
        dob: values.dob.format('YYYY-MM-DD'),
      },
      () => {
        setIsLoading(false);
        navigate(`/auth/verify-email`, { state: { email: values.email } });
      },
      ({ errorMessage }) => {
        setIsLoading(false);
        message.error(errorMessage);
      },
    );
  };

  return (
    <div className='signup'>
      <div className='signup-content'>
        <Form
          className='signup-form'
          name='basic'
          layout='vertical'
          initialValues={{ remember: true }}
          onFinish={onSubmit}>
          <Row gutter={[8, 16]}>
            <Col span={24}>
              <Form.Item
                name='email'
                label={'Email Address'}
                className='form-field'
                requiredMark='optional'
                rules={[
                  {
                    required: true,
                    message: 'Please input your Email Address!',
                  },
                ]}>
                <Input placeholder='Email' />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col xs={24} md={12} lg={12} xl={12} xxl={12}>
              <Form.Item
                name='firstName'
                label={'First Name'}
                className='form-field'
                requiredMark='optional'
                rules={[
                  { required: true, message: 'Please input your First Name!' },
                ]}>
                <Input placeholder='First Name' />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={12} xl={12} xxl={12}>
              <Form.Item
                name='lastName'
                label={'Last Name'}
                className='form-field'
                requiredMark='optional'
                rules={[
                  { required: true, message: 'Please input your Last Name!' },
                ]}>
                <Input placeholder='Last Name' />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 16]}>
            <Col xs={24} md={12} lg={12} xl={12} xxl={12}>
              <Form.Item
                name='dob'
                label={'Date of Birth'}
                className='form-field form-item-w-100'
                requiredMark='optional'
                rules={[
                  {
                    required: true,
                    message: 'Please select your Date of Birth!',
                  },
                ]}>
                <DatePicker
                  placeholder='Select your Date of Birth'
                  allowClear
                  disabledDate={(current) => {
                    let customDate = moment().format('YYYY-MM-DD');
                    return (
                      current && current > moment(customDate, 'YYYY-MM-DD')
                    );
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={12} xl={12} xxl={12}>
              <Form.Item
                name='gender'
                label={'Gender'}
                className='form-field gender form-item-w-100'
                requiredMark='optional'
                rules={[
                  { required: true, message: 'Please select your Gender!' },
                ]}>
                <Radio.Group optionType='button'>
                  <Radio.Button
                    style={{ borderRadius: 50, marginRight: 12 }}
                    value='Male'>
                    Male
                  </Radio.Button>
                  <Radio.Button
                    style={{ borderRadius: 50, borderLeftWidth: 1 }}
                    value='Female'>
                    Female
                  </Radio.Button>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[8, 16]}>
            <Col xs={24} md={24} lg={24} xl={24} xxl={24}>
              <Form.Item
                name='password'
                className='form-field'
                label={'Password'}
                requiredMark='optional'
                rules={[
                  { required: true, message: 'Please input your Password!' },
                ]}>
                <Input.Password placeholder={messages['common.password']} />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            className='form-field signup-checkbox'
            name='iAgreeTo'
            valuePropName='checked'>
            <Checkbox defaultChecked>
              <IntlMessages id='common.iAgreeTo' />
            </Checkbox>
            <Link
              to='/terms-and-conditions'
              target={'_blank'}
              className='signup-link'>
              <IntlMessages id='common.termConditions' />
            </Link>
          </Form.Item>
          <div className='form-btn-field'>
            <Button
              type='primary'
              htmlType='submit'
              className='signup-btn'
              loading={isLoading}
              block>
              <IntlMessages id='common.signup' />
            </Button>
          </div>
        </Form>

        <Divider plain className='t-gray'>
          OR SIGN IN WITH
        </Divider>
        <div className='d-justify-center'>
          <LoginWithSocial />
        </div>
      </div>
    </div>
  );
};

export default SignupJwtAuth;
